var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paper',{staticClass:"banner-root"},[(_vm.img)?_c('div',{staticClass:"image-wrapper"},[_c('img',{staticClass:"image",attrs:{"src":_vm.img}})]):_vm._e(),_c('div',{staticClass:"p-4"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('h6',{staticClass:"caption"},[_vm._v(_vm._s(_vm.body))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }